const Restrictions = require('./restrictions');

class StatsUnique {
  /*:: static fromJson: (Object) => StatsUnique */
  constructor(count
  /*: number*/
  , restrictions
  /*: Restrictions*/
  ) {
    this.count = count;
    this.restrictions = restrictions;
  }

}

StatsUnique.fromJson = (json
/*: Object*/
) =>
/*: StatsUnique*/
new StatsUnique(json.count, Restrictions.fromJson(json.restrictions));

module.exports = StatsUnique;